import React, { useEffect, useState } from "react";
import Card from "components/common/Card";
import { Msg } from "./components/Msg";
import { OurAdvice } from "./components/OurAdvice";
import PolicyActions from "./components/PolicyActions";
import { OurRecommend } from "./components/OurRecommend";
import { Disclaimer } from "./components/Disclaimer";
import ButtonOutline from "components/semantic/ButtonOutline";
import Button from "components/semantic/Button";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getHealthResultThunk, getSinglePolicy } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import ResultHeading from "./components/Heading";
import MailCopyModal from "./components/MailCopyModal";
import PaymentCard from "pages/benefitSummary/components/PaymentCard";
import { BlurScreenResult } from "./components/blurScreenResult";
import PolicySkeletonCard from "./components/SkeletonCard";
import { HeadingSmallScreen } from "./components/headingSmallScreen";
import { onGmailShare } from "utils/utils";

const HealthResult: React.FC = () => {
  const param: any = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showCopyModal, setShowCopyModal] = useState(false);

  const healthQualityResult = useAppSelector((state) => state.rootReducer.kypSlice.healthQualityResult);
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);
  const policyType_Id = policyData?.policyTypeId === "3030b68f-82e9-4dfb-b2b8-82b743d0692a";
  const fromHospital = policyData?.fromHospital === true;
  
  useEffect(() => {
    dispatch(getSinglePolicy(param?.policyId));
    dispatch(getHealthResultThunk(param?.policyId));
  }, [dispatch, param]);

  const goToHomeHandler = () => {
    navigate("/kyp/policies");
  };

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-2xl font-extrabold mb-6">Know Your Policy</h1>
      {/* While res getting skeleton */}
      {!policyData || !healthQualityResult ? (
        <PolicySkeletonCard />
      ) : (
        <>
          {!["PAID", "WAIVEOFF"].includes(policyData.kypPaymentStatus) ? (
            <>
              <BlurScreenResult type={healthQualityResult.ResultTitle} />
              <PaymentCard feeAmount={policyData.kypFeeAmount} />
            </>
          ) : (
            <Card className="rounded-xl md:shadow-sm shadow-none overflow-hidden" parentClassName=" !shadow-none md:shadow-xl border-none md:border-[1px]" bg="bg-none md:bg-white">
              <ResultHeading resultData={healthQualityResult} />
              {(policyType_Id && fromHospital) ? null : healthQualityResult.ResultTitle && <Msg policyData={healthQualityResult} />}
              <div className="md:hidden sm:px-6">
              <HeadingSmallScreen onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(healthQualityResult)} policyData={healthQualityResult} policyType={policyData.policyTypeId} fromHospital={fromHospital} policyTypeId={policyType_Id}/>
            </div>
              <div className="sm:px-6 mx-0 md:mx-6">
                {(policyType_Id && fromHospital) ? null : healthQualityResult.ResultTitle !== "Healthy" && <OurAdvice onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(healthQualityResult)} policyData={healthQualityResult} />}
                {healthQualityResult.ResultTitle && <PolicyActions type={healthQualityResult.ResultTitle} onDownload={() => window.open(healthQualityResult.detailedKypPdfUrl)} onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(healthQualityResult)} id={policyData.policyTypeId} detailedKypPdfUrl={healthQualityResult?.detailedKypPdfUrl} />}
                <OurRecommend />
                {(policyType_Id && fromHospital) ? null : healthQualityResult.ResultTitle !== "Healthy" && <Disclaimer bg={true} />}
              </div>
              <div className="flex gap-1 md:gap-4 justify-center items-center py-5 px-2 w-full md:px-5 border-t md:rounded-none rounded-xl bg-white">
                <ButtonOutline title="Go To Home" onClick={goToHomeHandler} className="w-full border-gray-300" />
                <Button title="Check Another Policy" onClick={() => navigate("/kyp/upload-policy")} className="w-full mx-1 text-sm md:text-base" />
              </div>
            </Card>
          )}
          <MailCopyModal isOpen={showCopyModal} onClose={() => setShowCopyModal(!showCopyModal)} mailDetails={healthQualityResult?.Draft} />
        </>
      )}
    </div>
  );
};

export default HealthResult;
